(() => {
  function init(scope) {
    if (!document.querySelector('.sa-collection-hero')) return;
    scope.querySelectorAll('[data-sa-collection]').forEach(root => {
      if (root.classList.contains('sa-compact-ready') || !root.dataset.ready) return;
      const toolbar = root.querySelector('.sa-c-toolbar');
      const originals = [root.querySelector('[data-sa-c-style]'), root.querySelector('[data-sa-c-color]'), root.querySelector('[data-sa-c-sort]')];
      const originalClear = root.querySelector('.sa-c-clear');
      if (!toolbar || originals.some(item => !item) || !originalClear || !root.querySelector('[data-sa-c-card]')) return;
      const mobile = document.createElement('div');
      mobile.className = 'sa-c-mobile-bar';
      const names = ['Style', 'Color', 'Sort'];
      const attributes = ['data-sa-c-style', 'data-sa-c-color', 'data-sa-c-sort'];
      const copies = originals.map((original, index) => {
        const label = document.createElement('label');
        label.className = 'sa-c-mobile-select';
        const title = document.createElement('span');
        title.textContent = names[index];
        const arrow = document.createElement('span');
        arrow.className = 'sa-c-mobile-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        const copy = original.cloneNode(true);
        copy.removeAttribute(attributes[index]);
        copy.removeAttribute('id');
        copy.removeAttribute('name');
        copy.setAttribute('aria-label', names[index]);
        label.append(title, arrow, copy);
        mobile.append(label);
        return copy;
      });
      const active = document.createElement('div');
      active.className = 'sa-c-mobile-active';
      active.hidden = true;
      const activeText = document.createElement('span');
      const clear = document.createElement('button');
      clear.type = 'button';
      clear.textContent = 'Clear all';
      active.append(activeText, clear);
      toolbar.append(mobile);
      toolbar.insertAdjacentElement('afterend', active);
      function sync() {
        copies.forEach((copy, index) => { copy.value = originals[index].value; });
        const chosen = [];
        if (copies[0].value !== 'all') chosen.push(copies[0].selectedOptions[0]?.textContent || copies[0].value);
        if (copies[1].value !== 'all') chosen.push(copies[1].selectedOptions[0]?.textContent || copies[1].value);
        if (copies[2].value !== 'featured') chosen.push(copies[2].selectedOptions[0]?.textContent || copies[2].value);
        active.hidden = chosen.length === 0;
        activeText.textContent = chosen.join(' · ');
        copies.forEach((copy, index) => copy.parentElement.classList.toggle('is-active', index < 2 ? copy.value !== 'all' : copy.value !== 'featured'));
      }
      copies.forEach((copy, index) => {
        const original = originals[index];
        copy.addEventListener('change', () => {
          if (original.value !== copy.value) history.pushState(null, '', location.href);
          original.value = copy.value;
          original.dispatchEvent(new Event('change', {bubbles: true}));
          sync();
        });
        original.addEventListener('change', sync);
      });
      clear.addEventListener('click', () => {
        if (originals[0].value !== 'all' || originals[1].value !== 'all' || originals[2].value !== 'featured') history.pushState(null, '', location.href);
        originalClear.click();
        sync();
      });
      window.addEventListener('popstate', sync);
      root.querySelector('[data-sa-c-style-nav]')?.addEventListener('click', () => setTimeout(sync, 0));
      root.querySelectorAll('[data-sa-c-reset]').forEach(button => button.addEventListener('click', () => setTimeout(sync, 0)));
      sync();
      root.classList.add('sa-compact-ready');
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
